module.exports = __webpack_public_path__ + "img/emptystate_screwdriver.13643a34.svg";